<template>
  <layout>
    <page-header :header="$t('reviews.edit_review')" />
    <div class="content">
      <b-row>
        <b-col xl="9">
          <b-card>
            <div class="card-body">
              <b-row class="review_driver">
                <b-col lg="6" class="col-rating">
                  <div class="total_rating_wrap">
                    {{ $t('bookings.total_rating') }}:
                    <span>{{ total_rating }}</span>
                  </div>
                  <div class="form-group row mb-1">
                    <label class="col-4 col-form-label">
                      {{ $t('bookings.rating_star_punctual') }}
                    </label>
                    <div class="col-8">
                      <rate
                        :length="5"
                        :value="rating_punctual"
                        :disabled="!enabled"
                        name="rating_punctual"
                      />
                    </div>
                  </div>
                  <div class="form-group row mb-1">
                    <label class="col-4 col-form-label">
                      {{ $t('bookings.rating_star_comfort') }}
                    </label>
                    <div class="col-8">
                      <rate
                        :length="5"
                        :value="rating_comfort"
                        :disabled="!enabled"
                        name="rating_comfort"
                      />
                    </div>
                  </div>
                  <div class="form-group row mb-1">
                    <label class="col-4 col-form-label">
                      {{ $t('bookings.rating_star_clear') }}
                    </label>
                    <div class="col-8">
                      <rate
                        :length="5"
                        :value="rating_clean"
                        :disabled="!enabled"
                        name="rating_clean"
                      />
                    </div>
                  </div>
                </b-col>

                <b-col lg="6">
                  <div class="form-group wrap_comment_tip">
                    <label for="comment" class="col-form-label text-sm-right">
                      {{ $t('bookings.rating_commit') }}
                    </label>
                    <textarea
                      id="comment"
                      :maxlength="maxlength"
                      v-model="comment"
                      :disabled="!enabled"
                      class="form-control"
                      rows="6"
                    />
                    <span class="comment_tip">
                      {{ $t('bookings.review_max') }}
                      {{ maxlength - comment.length }}
                      {{ $t('bookings.review_characters') }}
                    </span>
                  </div>

                  <b-form-group :label="$t('reviews.company_reply')">
                    <b-textarea :value="company_reply" readonly class="reply" />
                  </b-form-group>

                  <b-form-group :label="$t('reviews.admin_reply')">
                    <b-textarea v-model="admin_reply" class="reply" />
                  </b-form-group>

                  <div class="">
                    <b-button
                      type="button"
                      variant="primary"
                      @click="sendReview"
                    >
                      {{ $t('bookings.rating_submit') }}
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </layout>
</template>

<script>
// import ResourceForm from './Form.vue'
import rate from '../components/Rating.vue'
const resourceBase = 'reviews'

export default {
  name: 'ReviewEdit',

  components: {
    rate,
  },
  data() {
    return {
      rating_punctual: 0,
      rating_comfort: 0,
      rating_courtesy: 0,
      rating_clean: 0,
      comment: '',
      review_saved: false,
      maxlength: 1000,
      total_rating: 0,
      review_id: 0,
      blocked: false,
      driver_id: 0,
      enabled: true,
      company_reply: '',
      admin_reply: '',
    }
  },

  created() {
    this.getReview()
  },

  methods: {
    returnBack() {
      this.$router.push({ path: `/drivers/${this.driver_id}/${resourceBase}` })
    },
    getReview() {
      let self = this
      self.disabled = true
      let id = this.$route.params.id
      let promise = this.$http.get('reviews/review?review_id=' + id)
      self.$uiBlocker(promise, this.$refs.content)
      promise.then(result => {
        if (result.data === '') {
          self.enabled = true
        } else {
          self.total_rating = result.data.average
          self.rating_punctual = result.data.punctual
          self.rating_comfort = result.data.comfort
          self.rating_clean = result.data.clean
          self.comment = result.data.text
          self.review_id = result.data.id
          self.review_exists = true
          self.enabled = true
          self.company_reply = result.data.company_reply
          self.admin_reply = result.data.admin_reply
        }
      })
    },
    sendReview() {
      let self = this
      let rating_punctual = document.querySelector(
        '.review_driver input[name=rating_punctual]',
      ).value
      let rating_comfort = document.querySelector(
        '.review_driver input[name=rating_comfort]',
      ).value
      let rating_clean = document.querySelector(
        '.review_driver input[name=rating_clean]',
      ).value
      let id = this.$route.params.id

      let args = {
        text: this.comment,
        punctual: rating_punctual,
        comfort: rating_comfort,
        //courtesy: this.rating_courtesy,
        clean: rating_clean,
        admin_reply: self.admin_reply,
      }
      args._method = 'PUT'
      let promise = this.$http.post('reviews/' + id, args)
      self.$uiBlocker(promise, this.$refs.content)
      promise.then(result => {
        if (result.data) {
          self.total_rating = result.data.average
          self.$toast.success('Review success updated!')
          self.review_exists = true
        }
      })
    },
  },
}
</script>

<style scoped>
.col-rating {
  min-width: 240px;
}
</style>
